import {Category} from './category';
import {Profile} from './profile';

export class MerchantDetail {
  profile: Profile;
  categories: Category[];
  tax: number;
}

